<button
  type="button"
  class="sz-profile-menu__avatar"
  [class.sz-profile-menu__avatar--active]="open()"
  [class.sz-profile-menu__avatar--has-badge]="hasOptionalUpdate()"
  (click)="toggle()"
  aria-haspopup="menu"
  [attr.aria-expanded]="open()"
  [attr.aria-label]="'profile.menu.toggleAria' | translate">
  @if (avatarUrl(); as url) {
    <img class="sz-profile-menu__avatar-img" [src]="url" alt="" />
  } @else {
    <span class="sz-profile-menu__avatar-initial">{{ initial() }}</span>
  }
  @if (hasOptionalUpdate()) {
    <span class="sz-profile-menu__avatar-badge" aria-hidden="true"></span>
  }
</button>

@if (open()) {
  <div class="sz-profile-menu__backdrop" (click)="close()"></div>
  <div class="sz-profile-menu__panel" role="menu">
    <div class="sz-profile-menu__header">
      <div class="sz-profile-menu__dd-avatar">
        @if (avatarUrl(); as url) {
          <img class="sz-profile-menu__dd-avatar-img" [src]="url" alt="" />
        } @else {
          <span>{{ initial() }}</span>
        }
      </div>
      <div class="sz-profile-menu__identity">
        @if (displayName(); as name) {
          <div class="sz-profile-menu__name">{{ name }}</div>
        }
        @if (email(); as e) {
          <div class="sz-profile-menu__email">{{ e }}</div>
        }
      </div>
    </div>

    <div class="sz-profile-menu__section">
      <button type="button" class="sz-profile-menu__item" role="menuitem" (click)="selectMyProfile()">
        <span class="sz-profile-menu__ico"><sz-icon name="user" [size]="14" /></span>
        <span class="sz-profile-menu__nm">{{ 'profile.menu.myProfileCta' | translate }}</span>
        <span class="sz-profile-menu__arr"><sz-icon name="arrow-right" [size]="12" /></span>
      </button>
    </div>

    <div class="sz-profile-menu__section">
      <button type="button" class="sz-profile-menu__item" role="menuitem" (click)="selectContact()">
        <span class="sz-profile-menu__ico"><sz-icon name="mail" [size]="14" /></span>
        <span class="sz-profile-menu__nm">{{ 'profile.menu.contactCta' | translate }}</span>
        <span class="sz-profile-menu__arr"><sz-icon name="arrow-right" [size]="12" /></span>
      </button>
    </div>

    <div class="sz-profile-menu__section">
      <button type="button" class="sz-profile-menu__item" role="menuitem" (click)="selectWhatsNew()">
        <span class="sz-profile-menu__ico"><sz-icon name="flame" [size]="14" /></span>
        <span class="sz-profile-menu__nm">{{ 'profile.menu.whatsNewCta' | translate }}</span>
        <span class="sz-profile-menu__arr"><sz-icon name="arrow-right" [size]="12" /></span>
      </button>
    </div>

    <div class="sz-profile-menu__section">
      <button type="button" class="sz-profile-menu__item" role="menuitem" (click)="selectChangeLanguage()">
        <span class="sz-profile-menu__ico"><sz-icon name="user" [size]="14" /></span>
        <span class="sz-profile-menu__nm">{{ 'profile.menu.changeLanguageCta' | translate }}</span>
        <span class="sz-profile-menu__current-lang">{{ currentLang() | uppercase }}</span>
        <span class="sz-profile-menu__arr"><sz-icon name="arrow-right" [size]="12" /></span>
      </button>
    </div>

    <div class="sz-profile-menu__section">
      <button type="button" class="sz-profile-menu__item" role="menuitem" (click)="selectPartners()">
        <span class="sz-profile-menu__ico"><sz-icon name="lock" [size]="14" /></span>
        <span class="sz-profile-menu__nm">{{ 'profile.menu.partnersCta' | translate }}</span>
        <span class="sz-profile-menu__arr"><sz-icon name="arrow-right" [size]="12" /></span>
      </button>
    </div>

    @if (hasOptionalUpdate()) {
      <div class="sz-profile-menu__section">
        <button
          type="button"
          class="sz-profile-menu__item sz-profile-menu__item--highlight"
          role="menuitem"
          (click)="selectDownloadUpdate()">
          <span class="sz-profile-menu__ico"><sz-icon name="download" [size]="14" /></span>
          <span class="sz-profile-menu__nm">
            {{ 'profile.menu.updateAvailableCta' | translate }}
          </span>
          <span class="sz-profile-menu__arr"><sz-icon name="arrow-right" [size]="12" /></span>
        </button>
      </div>
    }

    <div class="sz-profile-menu__section">
      <button
        type="button"
        class="sz-profile-menu__item sz-profile-menu__item--destructive"
        role="menuitem"
        (click)="selectSignOut()">
        <span class="sz-profile-menu__ico"><sz-icon name="log-out" [size]="14" /></span>
        <span class="sz-profile-menu__nm">{{ 'profile.menu.signOutCta' | translate }}</span>
      </button>
    </div>
  </div>
}
